import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./breadcrumb-pill.css";

function BreadcrumbPill({ title, onClick }) {
    return (
        <button onClick={onClick} className={styles.pill}>
            <span>{title}</span>
            <span className={styles.cross}>
                <SVGIcon name="cross" />
            </span>
        </button>
    );
}

export default BreadcrumbPill;

BreadcrumbPill.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};
